import React from "react";
import { displayStatus } from "../../utils/common";

const isDone = (s) => {
  const v = String(s).toLowerCase();
  return v.includes("complet") || v.includes("closed");
};

// Status -> colour tag
const statusClass = (s) => {
  const v = String(s).toLowerCase();
  if (v.includes("complet") || v.includes("closed")) return "ai-tag-green";
  if (v.includes("progress")) return "ai-tag-blue";
  if (v.includes("hold")) return "ai-tag-amber";
  if (v.includes("test")) return "ai-tag-purple";
  if (v.includes("not possible")) return "ai-tag-red";
  return "ai-tag-gray"; // Not Started / unknown
};

// Priority -> colour tag
const priorityClass = (p) => {
  const v = String(p).toLowerCase();
  if (v === "high") return "ai-tag-red";
  if (v === "medium") return "ai-tag-amber";
  if (v === "low") return "ai-tag-green";
  return "ai-tag-gray";
};

const AGING_DAYS = 2;

const TaskCard = ({ t }) => {
  const aging = t.ageDays != null && t.ageDays > AGING_DAYS && !isDone(t.status);

  return (
    <div className={`ai-task-card ${aging ? "aging" : ""} ${isDone(t.status) ? "done" : ""}`}>
      <div className="ai-task-head">
        <span className="ai-task-no">No: {t.no}</span>
        {aging && (
          <span className="ai-task-alert" title="Still pending">
            ⏳ {t.ageDays} days pending — needs attention
          </span>
        )}
      </div>

      <div className="ai-task-field">
        <span className="ai-task-label">Created:</span> {t.created}
      </div>
      <div className="ai-task-field">
        <span className="ai-task-label">Age:</span>{" "}
        <span className={aging ? "ai-age-critical" : "ai-age-ok"}>
          {t.ageDays != null ? `${t.ageDays}d` : "-"}
        </span>
      </div>
      <div className="ai-task-field">
        <span className="ai-task-label">Client:</span> {t.client}
      </div>
      <div className="ai-task-field">
        <span className="ai-task-label">Task:</span> {t.task}
      </div>
      <div className="ai-task-field">
        <span className="ai-task-label">Status:</span>{" "}
        <span className={`ai-tag ${statusClass(t.status)}`}>{displayStatus(t.status)}</span>
      </div>
      <div className="ai-task-field">
        <span className="ai-task-label">Priority:</span>{" "}
        <span className={`ai-tag ${priorityClass(t.priority)}`}>
          {t.priority}
        </span>
      </div>
    </div>
  );
};

const TaskCards = ({ tasks = [], overview }) => {
  if (!Array.isArray(tasks) || tasks.length === 0) return null;

  return (
    <div className="ai-tasks">
      {overview && (
        <div className="ai-overview-chips">
          <span className="ai-chip ai-chip-total">Total {overview.total}</span>
          <span className="ai-chip ai-chip-open">Open {overview.open}</span>
          {overview.completed > 0 && (
            <span className="ai-chip ai-chip-done">
              Completed {overview.completed}
            </span>
          )}
          {overview.agingCount > 0 && (
            <span className="ai-chip ai-chip-alert">
              {overview.agingCount} aging
            </span>
          )}
        </div>
      )}

      {/* Status-wise split, e.g. In Progress 2 · On Hold 8 · Not Possible 8 */}
      {overview?.byStatus &&
        Object.entries(overview.byStatus).some(([, c]) => c > 0) && (
          <div className="ai-overview-chips ai-status-chips">
            {Object.entries(overview.byStatus)
              .filter(([, count]) => count > 0)
              .map(([status, count]) => (
                <span key={status} className={`ai-chip ${statusClass(status)}`}>
                  {displayStatus(status)} {count}
                </span>
              ))}
          </div>
        )}

      {tasks.map((t) => (
        <TaskCard key={t.no} t={t} />
      ))}
    </div>
  );
};

export default TaskCards;
